import AadhaarMasking from './AadhaarMasking';
import AadhaarOCR from './AadhaarOCR';
import AadhaarOKYC from './AadhaarOKYC';
import AdvanceEmployment from './AdvanceEmployment';
import Bav from './Bav';
import Cin from './Cin';
import Digilocker from './Digilocker';
import DL from './DL';
import Esign from './E-Sign';
import FaceMatch from './FaceMatch';
import Gstin from './Gstin';
import LivelinessCheck from './LivelinessCheck';
import NameMatch from './NameMatch';
import Pan from './Pan';
import Pan360 from './Pan360';
import PanGstin from './PanGstin';
import PanOCR from './PanOCR';
import Passport from './Passport';
import ReverseGeocoding from './ReverseGeocoding';
import ReversePennyDrop from './ReversePennyDrop';
import UPIVPA from './UPI-VPA';
import Upi from './UPI';
import Upi360 from './Upi360';
import VehicleRC from './VehicleRC';
import VoterId from './VoterId';
import IFSC from './Ifsc';
import PanLite from './PanLite';
import InputField from './InputField';

export default {
  AadhaarMasking,
  AadhaarOCR,
  AadhaarOKYC,
  AdvanceEmployment,
  Bav,
  Cin,
  Digilocker,
  DL,
  Esign,
  FaceMatch,
  Gstin,
  LivelinessCheck,
  NameMatch,
  Pan,
  Pan360,
  PanGstin,
  PanOCR,
  Passport,
  ReverseGeocoding,
  ReversePennyDrop,
  VoterId,
  Upi,
  UPIVPA,
  Upi360,
  VehicleRC,
  IFSC,
  PanLite,
  InputField,
};
